import React from "react";

import { browser } from "@workspace/mobile";
import { Button } from "../../../../Shared/Buttons/Button";
import { BannerTitle } from "../../../../Shared/Headings/BannerTitle";

import { useUserContext } from "../../../../../hooks/useUserContext";
import { dmnIdentity } from "../../../../../utils/dmnIdentity";
import noAccessImage from "../../../../../assets/placeholders/no-access.png";

export const SoonContent = () => {
  const { user } = useUserContext();

  return (
    <div className="SoonContent bg-[var(--diaryGridSolid)] h-full w-full flex flex-col justify-center items-center text-center">
      <div className="SoonContent__body">
        <img width="280" src={noAccessImage} alt="Soon" />
        <BannerTitle title="Coming Soon" />
        <p className="max-w-[800px]">
          Thank you for your interest, {user?.first_name}. The app is currently
          in a limited trial phase, but will be released soon. If you believe
          this is a mistake and you should have access to the application then
          please get in touch.
        </p>
        <div className="SoonContentActionButtons w-[400px] mx-auto mt-5 flex">
          <div className="SoonContentActionButton w-[160px] mx-auto">
            <Button
              fill={"outline"}
              expand={true}
              size={"lg"}
              onClick={() => {
                browser.open(
                  "https://access-support.force.com/Support/s/login/",
                  "external"
                );
              }}
            >
              Contact Us
            </Button>
          </div>
          <div className="SoonContentActionButton w-[160px] mx-auto">
            <Button
              fill={"outline"}
              expand={true}
              size={"lg"}
              onClick={dmnIdentity.signOut}
            >
              Sign out
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
